module.exports = __webpack_public_path__ + "img/germany-colorectal-cancer-male.c29c7979.png";